import { fetchPaginatedResults } from "../utils/fetchPaginatedResults";

const initializedSelectors = new Set<string>();

export const pagination = ({
    loadMoreButtonSelector,
    resultsContainerSelector,
}: {
    loadMoreButtonSelector: string;
    resultsContainerSelector: string;
}) => {
    if (initializedSelectors.has(loadMoreButtonSelector)) return;

    const container = document.querySelector<HTMLElement>(
        resultsContainerSelector,
    );
    if (!container) return;

    initializedSelectors.add(loadMoreButtonSelector);

    container.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;
        if (
            target.matches(loadMoreButtonSelector) ||
            target.closest(loadMoreButtonSelector)
        ) {
            const button = target.closest<HTMLButtonElement>(
                loadMoreButtonSelector,
            );
            if (!button) return;

            const nextPageUrl = button.dataset.next;
            if (!nextPageUrl) return;
            button.disabled = true;

            fetchPaginatedResults(
                nextPageUrl,
                container,
                resultsContainerSelector,
                loadMoreButtonSelector,
            );
        }
    });
};
